var _defs, _polygon, _polygon2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _polygon3, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLong({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 564.47 58.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e6e6e6;}.cls-2{fill:#ffc500;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Civil Tracker - W&amp;amp;Y - wide") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "55.15 51.22 11.96 51.22 33.55 13.8 43.12 30.37 51.09 30.37 33.55 0 0 58.12 67.11 58.12 63.12 51.22 55.15 51.22"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "63.46 38.42 60.07 32.09 36.02 32.09 38.92 38.42 48 38.42 54.66 49.58 62.3 49.3 55.81 38.42 63.46 38.42"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M158.93,72.8a21.43,21.43,0,0,1-15.37,6.07c-14.84,0-21.5-10.22-21.56-21S129,36.46,143.56,36.46a20.91,20.91,0,0,1,15,6.19l-4.38,4.21a15.06,15.06,0,0,0-10.58-4.21c-10.4,0-15.13,7.66-15.07,15.19s4.5,14.9,15.07,14.9a15.88,15.88,0,0,0,10.87-4.44Z",
    transform: "translate(-33.88 -21.47)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168.74,78.06V37.16h6.49v40.9Z",
    transform: "translate(-33.88 -21.47)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M208,78.23h-6.83l-17-41.07h7.36l13,33.24,13.08-33.24H225Z",
    transform: "translate(-33.88 -21.47)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M233.94,78.06V37.16h6.49v40.9Z",
    transform: "translate(-33.88 -21.47)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260.41,37.16V72H282v6.08h-28.1V37.16Z",
    transform: "translate(-33.88 -21.47)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315,43.06H301.6v-5.9H335v5.9H321.64v35H315Z",
    transform: "translate(-33.88 -21.47)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M470.45,72.8a21.43,21.43,0,0,1-15.37,6.07c-14.83,0-21.5-10.22-21.55-21s7-21.44,21.55-21.44a20.89,20.89,0,0,1,15,6.19l-4.38,4.21a15,15,0,0,0-10.58-4.21c-10.39,0-15.13,7.66-15.07,15.19s4.5,14.9,15.07,14.9A15.86,15.86,0,0,0,466,68.3Z",
    transform: "translate(-33.88 -21.47)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M511.58,37.39,492.83,56.91l20.39,20.74v.41H505L486.81,59.42V78.06h-6.54V37.16h6.54V54.8l16.65-17.64h8.12Z",
    transform: "translate(-33.88 -21.47)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M378.9,76.89,366.69,63.28c8.06-1.17,11.1-6.9,11.1-12.74,0-6.89-5-13.38-14.43-13.38-6.37,0-12.68-.06-19.05-.06v6h19.05c5.37,0,7.77,3.86,7.77,7.54,0,3.85-2.4,7.3-7.83,7.3h-19v20.1h6.54V63.92h8.65L372,78.06h7.65Z",
    transform: "translate(-33.88 -21.47)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "376.57 15.69 369.44 15.69 351.1 56.59 358.05 56.59 361.91 48 364.36 42.04 373.01 22.58 381.65 42.04 384.05 48 387.96 56.59 394.92 56.59 376.57 15.69"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M527.83,71.63v-11h22.55V54.57h-29.1V78.06h30.21V71.63Z",
    transform: "translate(-33.88 -21.47)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M527.83,43.53h23.48V37.16h-30v6.37Z",
    transform: "translate(-33.88 -21.47)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M597.64,76.89,585.43,63.28c8.07-1.17,11.1-6.9,11.1-12.74,0-6.89-5-13.38-14.43-13.38-6.37,0-12.67-.06-19-.06v6h19c5.38,0,7.77,3.86,7.77,7.54,0,3.85-2.39,7.3-7.83,7.3h-19v20.1h6.54V63.92h8.65l12.44,14.14h7.66Z",
    transform: "translate(-33.88 -21.47)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLong);
export default __webpack_public_path__ + "static/media/logo-long.5d420d60e4a75f6e102df93e60fbf126.svg";
export { ForwardRef as ReactComponent };